


























































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { Ref } from '@vue/composition-api'
import { formFieldProps } from '~/constants/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import DescriptionContent from '~/components/car/classifieds/view/partials/DescriptionContent.vue'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import { ciAngleDown } from '~/icons/source/regular/angle-down'
import { ciAngleUp } from '~/icons/source/regular/angle-up'

export default defineComponent({
  components: {
    CExpandableContent,
    DescriptionContent,
    CCustomSelect,
    FieldError
  },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const value = ref<string[]>([])
    const showMobileMore = ref(false)
    const featuresFieldsetElement = ref<HTMLElement | null>(null)

    const { t } = useI18n()

    function onValue(v: Ref<string[]>) {
      value.value = v.value || []
    }

    const { error, valueChanged } = useClassifiedForm(props, { onValue })

    const options = computed(() => specs.value?.values || [])
    const selectOptions = computed(() =>
      options.value.map(c => {
        return { text: c.name, value: c.value }
      })
    )

    onMounted(() => {
      const fieldsetElement = Array.from(
        document.getElementsByName('features')
      ).find(e => {
        return e.tagName.toLowerCase() === 'fieldset'
      }) as HTMLElement

      if (fieldsetElement) {
        featuresFieldsetElement.value = fieldsetElement
      }
    })
    const groupedOptions = computed(() => {
      // Calculate the base index for each group
      const groupLimit = Math.floor(options.value.length / 4)

      const groups = Array.from({ length: 4 }, () => [])

      // if theres is a remainder then we add 1 to each column no matter what
      // case 1 = we add 1 to first, second and third col (and 4rth has -3)
      // case 2 = we add 1 to first, second and third col (and 4rth has -2)
      // case 3 = we add 1 to first, second and third col (and 4rth has -1)
      // case 4 = impossible, it will be 4 % 4 = 0
      let extra = options.value.length % 4 ? 1 : 0

      for (let i = 0; i < options.value.length; i++) {
        const groupIndex = Math.floor(i / (groupLimit + extra))

        if (groupIndex === 3 && extra % 4 !== 0) {
          extra = 0 // last column should not have any extras
        }

        if (!groups[groupIndex]) {
          groups[3].push(options.value[i])
          continue
        }
        groups[groupIndex].push(options.value[i])
      }

      return groups
    })
    const handleExtrasChange = (v: string[]) => {
      valueChanged(name.value, v)
    }

    const mobileOptionsToShow = computed(() => {
      if (showMobileMore.value) {
        return options.value
      }

      return [...options.value.slice(0, 20)] // first 10 lines
    })

    const getOrderClassForGroupIndex = (index: number) => {
      switch (index) {
        case 1: {
          return 'max-lg:tw-order-3'
        }
        case 2: {
          return 'max-lg:tw-order-2'
        }
        case 3: {
          return 'max-lg:tw-order-4'
        }
        case 0:
        default: {
          return 'max-lg:tw-order-1'
        }
      }
    }

    return {
      value,
      error,
      groupedOptions,
      handleExtrasChange,
      options,
      showMobileMore,
      mobileOptionsToShow,
      getOrderClassForGroupIndex,
      t,
      selectOptions,
      ciAngleDown,
      ciAngleUp,
      featuresFieldsetElement
    }
  },
  i18n: defineComponentTranslations({
    extras_select_placeholder: {
      en: 'Select extras',
      el: 'Επίλεξε ιδιαιτερότητες'
    },
    view_all_extras: {
      en: 'View all extras',
      el: 'Δες όλες τις ιδιαιτερότητες'
    }
  })
})
